import { transformNumberToBoolean } from '../transformNumber';
import { transformStringToNumber } from './transformStringToNumber';

export const TRUTHY_STRINGS = new Set<string>([
  'true',
  'yes',
  'checked',
  '是',
  '已勾选',
]);

export const transformStringToBoolean = (str: string): boolean => {
  if (TRUTHY_STRINGS.has(str.toLocaleLowerCase())) {
    return true;
  } else {
    const number = transformStringToNumber(str);
    if (number === null) return false;

    return transformNumberToBoolean(number);
  }
};
